import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Bell } from "@phosphor-icons/react";
import {
  Popover, PopoverContent, PopoverTrigger,
} from "@/components/ui/popover";
import { useNavigate } from "react-router-dom";
import { formatDistanceToNow, parseISO } from "date-fns";

export default function NotificationBell() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const unread = items.filter((i) => !i.read).length;

  const openBell = async (o) => {
    setOpen(o);
    if (o && unread > 0) {
      try {
        await api.post("/notifications/read");
        setTimeout(load, 300);
      } catch {}
    }
  };

  return (
    <Popover open={open} onOpenChange={openBell}>
      <PopoverTrigger asChild>
        <button
          data-testid="notifications-bell"
          className="relative p-2 rounded-md hover:bg-panel text-fg2 hover:text-fg"
        >
          <Bell size={18} weight={unread > 0 ? "fill" : "regular"} />
          {unread > 0 && (
            <span className="absolute top-1 right-1 min-w-[16px] h-4 px-1 rounded-full bg-[#FF3B30] text-white text-[10px] font-mono flex items-center justify-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="bg-surface border-line p-0 w-80">
        <div className="p-3 border-b border-line">
          <div className="ui-label">Notifications</div>
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-6 text-center text-sm text-fg3">You're all caught up.</div>
          ) : items.map((n) => (
            <button
              key={n.id}
              onClick={() => { if (n.link) nav(n.link); setOpen(false); }}
              data-testid={`notif-${n.id}`}
              className={`w-full text-left px-3 py-2.5 border-b border-line/60 hover:bg-panel transition ${!n.read ? "bg-[#FF3B30]/5" : ""}`}
            >
              <div className="text-sm">{n.message}</div>
              <div className="text-[10px] font-mono text-fg3 mt-1">
                {n.created_at ? formatDistanceToNow(parseISO(n.created_at), { addSuffix: true }) : ""}
              </div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
